import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-4 col-xxl-4 col-sm-4 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "text-black fw-bold mb-10" }
const _hoisted_6 = { class: "my-15" }
const _hoisted_7 = { class: "my-15" }
const _hoisted_8 = { class: "fw-bolder text-gray-600 mb-15" }
const _hoisted_9 = { class: "fw-bolder text-gray-600 mb-15" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_11 = { class: "col-md-8 col-xxl-8 col-sm-8" }
const _hoisted_12 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_13 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-15 mb-md-25 d-sm-flex align-items-center justify-content-between\"><h5 class=\"card-title fw-bold mb-0\">Liste des utilisateurs</h5><div class=\"card-select mt-10 mt-sm-0 d-inline-block d-sm-flex align-items-center ps-10 pe-10 pt-5 pb-5\"><form><div class=\"input-group\"><input type=\"text\" class=\"form-control shadow-none fw-medium ps-12 pt-8 pb-8 pe-12 letter-spacing\" placeholder=\"Search\"><button class=\"default-btn position-relative transition border-0 text-white ps-12 pe-12 rounded-1\" type=\"button\"><i class=\"flaticon-search-interface-symbol position-relative\"></i></button></div></form></div></div>", 1)
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, "Nom et prénom "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Email "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Statut ")
  ])
], -1)
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-success" }, "Actif")
], -1)
const _hoisted_21 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, null, -1)
const _hoisted_23 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_24 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-0 h2" }, "Liste des permissions")
], -1)
const _hoisted_26 = { class: "card-body pt-0" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "d-flex align-items-center py-2" }
const _hoisted_29 = { class: "col-8" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-primary me-3" }, null, -1)
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-primary me-3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "badge text-outline-danger" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.roleData?.description), 1),
          _createElementVNode("h5", _hoisted_6, "Key: " + _toDisplayString(_ctx.roleData?.nom), 1),
          _createElementVNode("p", _hoisted_7, "Date de création: " + _toDisplayString(_ctx.format_date(_ctx.roleData?.createdAt)), 1),
          _createElementVNode("div", _hoisted_8, "Nombre total de permission ayant ce rôle: " + _toDisplayString(_ctx.roleData?.rolePermissions?.length), 1),
          _createElementVNode("div", _hoisted_9, "Nombre total d'utilisateur ayant ce rôle: " + _toDisplayString(_ctx.roleData?.users?.length), 1),
          _createVNode(_component_router_link, {
            to: { name: 'EditRolePage', params: { id: _ctx.roleData?.id } },
            class: "btn btn-primary my-15 me-2"
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createTextVNode("Complèter un privilège ")
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("table", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleData?.users, (user, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("th", _hoisted_18, [
                      _createElementVNode("span", {
                        class: _normalizeClass(`badge text-outline-${_ctx.color} me-3 fw-bold rounded-circle`)
                      }, _toDisplayString(_ctx.getFirstletre(user.sexe)), 3),
                      _createTextVNode(" " + _toDisplayString(user.nomComplet), 1)
                    ]),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(user.email), 1),
                    _hoisted_20
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleData?.rolePermissions, (pri, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-6",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("p", _hoisted_31, _toDisplayString(pri?.permission?.description), 1)
                    ]),
                    _hoisted_32
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}